//self.__precacheManifest = [].concat(self.__precacheManifest || []);
//workbox.precaching.suppressWarnings();
//workbox.precaching.precacheAndRoute(self.__precacheManifest, {});

self.addEventListener('install', function () {
    console.log("Install ....................");
    self.skipWaiting();
});

self.addEventListener('push', function (e) {
    console.log('push',e);
    e.waitUntil((async () => {
        const data = e.data.json();

        let options = {
            body: data.Body,
            icon: '/img/icons/favicon-16x16.png',
            requesterId:data.RequesterId,
        
        };
        await self.registration.showNotification(data.Title, options);
    })());
});